<div class="center" style="background-image: url('../../../assets/Flag1.jpg'); background-size:100% 100%; background-position: bottom;">
    <div>
        <img src="assets/HomeLogo.png" width="125px" height="125px">
    </div>
    <div>
        <h5 class="center" style="color: #1f2d8a; font-weight: bold;">MILITARY ENGINEER SERVICES</h5>
        <h5 style="color: #1f2d8a; font-weight: bold;">CHIEF ENGINEER (NAVAL WORKS) - KOCHI ZONE</h5>
    </div>
</div>
<div id="wrapper">
    <div class="main-content">
        <div class="header center">
            <h4 style="color: #1f2d8a;">Forgot Password</h4>
        </div>
        <div class="l-part">
            <form [formGroup]="forgotPasswordForm" (ngSubmit)="submit()" *ngIf="!showChangePassword">
                <div>
                    <mat-form-field appearance="outline" class="center">
                        <mat-label>Username</mat-label>
                        <input matInput placeholder="Username" formControlName="userName" autocomplete="new-username" autocorrect="off"
                        spellcheck="false" (copy)="false" (cut)="false" (paste)="false">
                        <button mat-icon-button matSuffix>
                            <mat-icon matSuffix>person</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="center">
                        <mat-label>Mobile Number</mat-label>
                        <input matInput placeholder="Mobile Number" formControlName="mobileNumber" minlength="10" maxlength="10" autocomplete="new-mobile" autocorrect="off"
                        spellcheck="false" (copy)="false" (cut)="false" (paste)="false">
                        <button mat-icon-button matSuffix>
                            <mat-icon matSuffix>smartphone</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-form-field appearance="outline" *ngIf="showOtpField" class="center">
                        <mat-label>OTP</mat-label>
                        <input matInput placeholder="OTP" formControlName="otp" minlength="6" maxlength="6" autocomplete="new-otp" autocorrect="off"
                        spellcheck="false" (copy)="false" (cut)="false" (paste)="false">
                        <button mat-icon-button matSuffix>
                            <mat-icon matSuffix>pin</mat-icon>
                        </button>
                    </mat-form-field>
                    <p *ngIf="showOtpField">Max 3 OTP validation attempts are allowed</p>
                    <p *ngIf="showOtpField">OTP has been sent to your registered email: <strong>{{ maskedEmail }}</strong></p>
                </div>
            </form>
            <div *ngIf="!showChangePassword">
                <div class="center">
                    <ngx-turnstile [siteKey]="'0x4AAAAAAAkPiEx2XU2Pm46_'" 
                        (resolved)="sendCaptchaResponse($event)"
                        theme="light">
                    </ngx-turnstile>
                </div>
                <div *ngIf="isCooldownActive" class="center" style="color: #015CBB;">
                    Please wait for {{ cooldownTime }} seconds before requesting another OTP.
                </div>
                <div class="center" style="margin-top: 15px;">
                    <span>
                        <button *ngIf="resendOTPButton" mat-button [disabled]="isCooldownActive" (click)="resendOtp()">Resend OTP</button>
                    </span>
                </div>
            </div>
            <span class="center" *ngIf="!showChangePassword" style="margin-top: 10px;">
                <button mat-stroked-button (click)="backToLogin()">Back to Login</button>
                <button style="margin-left: 10px;" mat-flat-button [disabled]="disableSubmitButton" (click)="submit()">Proceed</button>
            </span>
            <div *ngIf="showChangePassword">
                <div>
                    <app-change-password></app-change-password>
                </div>
            </div>
        </div>
    </div>
</div>
